export default __webpack_public_path__ + "static/home4-d87d07f8670c91131549048466bba035.jpg";